import { ExternalConnectionsProviders } from '@griply/types';

import { FirebaseHttpsCallableFactory } from '../types/firebase-functions';

export type GetExternalConnectionAuthUrlPayload = {
  provider: ExternalConnectionsProviders;
  // Reconnect flows pass the existing connection's address so the provider preselects that
  // account — consenting as a different one creates a second connection instead of upgrading.
  email?: string;
};

export type GetExternalConnectionAuthUrlOptions<TFunctions> = {
  functions: TFunctions;
  httpsCallable: FirebaseHttpsCallableFactory<TFunctions>;
  payload: GetExternalConnectionAuthUrlPayload;
};

export const getExternalConnectionAuthUrl = async <TFunctions>(
  options: GetExternalConnectionAuthUrlOptions<TFunctions>,
): Promise<string> => {
  const { functions, httpsCallable, payload } = options;
  const callable = httpsCallable<GetExternalConnectionAuthUrlPayload, string>(
    functions,
    'externalConnections-getAuthenticationURL',
  );

  const { data } = await callable(payload);

  return data;
};
